const starFull = {
  name: 'star-full',
  style: 'line',
  path: `<path d="M 22,9.67 C 21.870976,9.2963039 21.533904,9.0337012 21.14,9 L 15.45,8.17 12.9,3 C 12.535719,2.2478532 11.464281,2.2478532 11.1,3 L 8.55,8.16 2.86,9 C 2.4824229,9.053667 2.1682441,9.3174219 2.05,9.68 c -0.1081156,0.353914 -0.011944,0.738601 0.25,1 l 4.13,4 -1,5.68 c -0.072893,0.382797 0.083217,0.773073 0.4,1 0.3084299,0.220495 0.7150303,0.247602 1.05,0.07 l 5.12,-2.67 5.1,2.68 c 0.140348,0.07918 0.29886,0.120528 0.46,0.12 0.211826,7.54e-4 0.418421,-0.06578 0.59,-0.19 0.316783,-0.226927 0.472893,-0.617203 0.4,-1 l -1,-5.68 4.13,-4 C 21.974699,10.44033 22.099268,10.043267 22,9.67 Z"/>`
}

export { starFull }
